import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lobby--team-form" or "lobby--player-form"
export default class extends Controller {
  static values = {
    url: String,
    paramRoot: { type: String, default: "lobby_team" },
    reloadOnSuccess: { type: Boolean, default: true },
  }

  disconnect() {
    if (this.feedbackClearTimeout) {
      clearTimeout(this.feedbackClearTimeout)
    }
  }

  update(event) {
    const input = event.target
    const field = input.dataset.field
    const raw = typeof input.value === "string" ? input.value.trim() : ""
    const value = this.coerceValue(input, raw)

    const data = {
      [this.paramRootValue]: {
        [field]: value,
      },
    }

    this.resetFieldFeedback(input)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          this.flashSuccess(input)
          if (this.reloadOnSuccessValue) {
            window.location.reload()
          }
        } else {
          this.flashError(input)
        }
      })
      .catch(() => {
        this.flashError(input)
      })
  }

  coerceValue(input, raw) {
    if (input.type === "checkbox") {
      return input.checked
    }

    if (input.tagName === "SELECT") {
      return raw === "" ? null : Number(raw)
    }

    if (raw === "") {
      return input.dataset.emptyAsZero === "true" ? 0 : null
    }

    return Number(raw)
  }

  resetFieldFeedback(input) {
    input.classList.remove("is-valid", "is-invalid")
    if (this.feedbackClearTimeout) {
      clearTimeout(this.feedbackClearTimeout)
      this.feedbackClearTimeout = null
    }
  }

  flashSuccess(input) {
    input.classList.remove("is-invalid")
    input.classList.add("is-valid")
    if (this.feedbackClearTimeout) clearTimeout(this.feedbackClearTimeout)
    this.feedbackClearTimeout = setTimeout(() => {
      input.classList.remove("is-valid")
      this.feedbackClearTimeout = null
    }, 2500)
  }

  flashError(input) {
    input.classList.remove("is-valid")
    input.classList.add("is-invalid")
  }
}
